import React, { useState, useRef, useEffect } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import zoomPlugin from 'chartjs-plugin-zoom';
import { Bar } from "react-chartjs-2"

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

const options = {
    plugins: {
        zoom: {
            zoom: {
                wheel: {
                    enabled: true,
                },
                pinch: {
                    enabled: true
                },
                drag: {
                    enabled: true
                },
                mode: 'x',
            }
        }
    }
}



function BarChart({ item, fixedS1, fixedS2, hideControls }) {

    const [label1, setLabel1] = useState('')
    const [label2, setLabel2] = useState('')
    const [data1, setData1] = useState([])
    const [data2, setData2] = useState([])
    const chartRef = useRef(null);

    useEffect(() => {
        var keysInit;
        if (item.length > 0) {
            keysInit = Object.keys(item[0])
            // Columnas fijadas por el autor (embed) o, si no, las dos primeras.
            var c1 = fixedS1 && keysInit.indexOf(fixedS1) !== -1 ? fixedS1 : keysInit[0]
            var c2 = fixedS2 && keysInit.indexOf(fixedS2) !== -1 ? fixedS2 : keysInit[1]
            setLabel1(c1)
            setLabel2(c2)
            changeHandler(c1)
            changeHandler2(c2)
        }

    }, [item, fixedS1, fixedS2])

    const changeHandler = (value) => {
        setData1([])
        setLabel1(value)
        item.map((item) => {
            setData1(data => ([...data, { 'label': [`${value}`], 'value': item[`${value}`] }]))
        })
    }
    const changeHandler2 = (value) => {
        setData2([])
        setLabel2(value)
        item.map((item) => {
            setData2(data => ([...data, { 'label': [`${value}`], 'value': item[`${value}`] }]))
        })
    }

    const resetZoom = () => {
        if (chartRef && chartRef.current) {
            chartRef.current.resetZoom();
        }
    };

    return (

        <>
            {!hideControls && (
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 form-group">
                        <label className="paragraph-graph">Serie 1</label>
                        <select className="form-control paragraph-graph" onChange={(event) => changeHandler(event.target.value)} value={label1}>
                            <option value="">Seleccione uno</option>
                            {Object.keys(item).length ? Object.keys(item[0]).map((item) => {
                                return (
                                    <option value={item}>{item}</option>
                                )
                            }) : null}
                        </select>
                    </div>
                    <div className="col-12 col-md-6 form-group">
                        <label className="paragraph-graph">Serie 2</label>
                        <select className="form-control paragraph-graph" onChange={(event) => changeHandler2(event.target.value)} value={label2}>
                            <option value="">Seleccione uno</option>
                            {Object.keys(item).length ? Object.keys(item[0]).map((item) => {
                                return (
                                    <option value={item}>{item}</option>
                                )
                            }) : null}
                        </select>
                    </div>
                </div>
            </div>
            )}

            <Bar ref={chartRef}
                data={{
                    labels: item.length > 0 ? item.map((data) => '') : [''],
                    datasets: [
                        {
                            label: label1,
                            data: data1.map((data) => data.value),
                            borderColor: 'rgb(53, 162, 235)',
                            backgroundColor: 'rgba(53, 162, 235, 0.5)',
                        },
                        {
                            label: label2,
                            data: data2.map((data) => data.value),
                            borderColor: 'rgb(255, 159, 64)',
                            backgroundColor: 'rgba(255, 159, 64, 0.5)',
                        }
                    ]
                }} options={options} />
            <a onClick={resetZoom} title="Ver" className='button button-secondary' target='_blank'>
                <i className='fa-solid fa-rotate-right' />
                {` Reset Zoom`}
            </a>

        </>
    )

}


export default BarChart